import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { adminMe, adminLogout } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // user: null = checking, false = unauthenticated, object = authenticated
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const me = await adminMe();
      setUser(me);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback((profile) => {
    // Cookie is set server-side by /api/auth/login; we only update local state.
    setUser(profile);
  }, []);

  const logout = useCallback(async () => {
    try {
      await adminLogout();
    } catch {
      /* ignore network errors — local state still cleared */
    }
    setUser(false);
  }, []);

  const value = useMemo(
    () => ({ user, login, logout, refresh }),
    [user, login, logout, refresh],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
